module.exports = __webpack_public_path__ + "img/area_multi.0f3e020f.svg";